import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Accordion, Select } from '../base'
import { MultiSelect } from '../base'
import { Slider } from 'components/base'
import { getDateByWeek } from 'components/GroupTitle/GroupTitle'
import { getWeek } from 'components/main/main.component'

const isMobile = window.innerWidth < 712

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
  padding-bottom: 60px;
  .actions {
    width: 100%;
    text-align: center;
    display: inline-block;
  }
`

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: ${isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'};
  grid-gap: 15px;
  justify-content: space-between;
  padding-top: 15px;
  padding-bottom: 0px;
  line-height: 1.2em;
  flex: 0 0 calc(100%);
  width: calc(100% + 15px);
`

export const Filters: React.FC<{
  setFilters: React.Dispatch<React.SetStateAction<newFiltersType>>
  labels: { [key: string]: any[] }
  locale: 'de' | 'fr'
  checkDate: Date | undefined
}> = ({ setFilters, labels, locale, checkDate }) => {
  const {} = labels

  //
  const [newFilters, setNewfilters] = useState<Partial<newFiltersType>>({
    availability: 'all',
    type: 'all',
    durability: 'all',
    usage: ['raw', 'cook', 'fry', 'steam', 'bake', 'waehe', 'compott'],
    lastCheckDate: checkDate || new Date('1980-05-11'),
    selectedDay: new Date(),
    selectedWeek: getWeek(new Date())
  })
  //

  useEffect(() => {
    setFilters({ ...newFilters, lastCheckDate: checkDate })
  }, [newFilters])

  const handleNewFiltersChange = (props: any) => {
    const { filterid, propid } = props
    setNewfilters({ ...newFilters, ...{ [filterid]: propid } })
  }
  const {
    availability,
    type,
    durability,
    usage,

    selectedWeek
  } = newFilters

  return (
    <>
      <FilterContainer className='FilterContainer'>
        <Accordion
          labels={labels.accordion}
          heightClosed={0}
          scrollOnClose={false}
        >
          <FilterGrid className='FilterGrid'>
            <div
              style={{
                gridColumnStart: isMobile ? '1' : '1',
                gridColumnEnd: isMobile ? 'span 2' : 'span 1',
                marginBottom: isMobile ? '15px' : undefined
              }}
            >
              <Select
                id={'type'}
                current={type || ''}
                entries={[
                  { label: labels.type[1], value: 0, id: 'all' },
                  { label: labels.type[2], value: 1, id: 'fruit' },
                  { label: labels.type[3], value: 2, id: 'vegetable' }
                ]}
                label={labels.type[0]}
                change={handleNewFiltersChange}
              />
            </div>
            <div
              style={{
                gridColumnStart: isMobile ? '1' : '2',
                gridColumnEnd: isMobile ? 'span 1' : 'span 1'
              }}
            >
              <Select
                id={'availability'}
                current={availability || ''}
                entries={[
                  { label: labels.availability[1], value: 0, id: 'all' },
                  // { label: labels.availability[2], value: 1, id: 'checked' },
                  {
                    label: labels.availability[3],
                    value: 2,
                    id: 'checkedAndAvailable'
                  }
                ]}
                label={labels.availability[0]}
                change={handleNewFiltersChange}
              />
            </div>
            <div
              style={{
                gridColumnStart: isMobile ? '2' : '3',
                gridColumnEnd: isMobile ? 'span 1' : 'span 1'
              }}
            >
              <Select
                id={'durability'}
                current={durability || ''}
                entries={[
                  { label: labels.durability[1], value: 0, id: 'all' },
                  { label: labels.durability[2], value: 0, id: '3days' },
                  { label: labels.durability[3], value: 1, id: '1week' },
                  { label: labels.durability[4], value: 2, id: '2weeks' }
                ]}
                label={labels.durability[0]}
                change={handleNewFiltersChange}
              />
            </div>{' '}
            <div
              style={{
                gridColumnStart: 1,
                gridColumnEnd: isMobile ? 'span 3' : 'span 3'
              }}
            >
              <Slider
                setValue={handleNewFiltersChange}
                currentValue={selectedWeek || 0}
                range={[1, 52]}
                labels={labels.time}
                lang={locale}
                valueLabel={(week: number) => {
                  week = Math.round(week)
                  return week == getWeek(new Date())
                    ? labels.time[1]
                    : getDateByWeek(2022, week, locale).join(' - ')
                }}
              />
            </div>
            <div
              style={{
                gridColumnStart: 1,
                gridColumnEnd: isMobile ? 'span 3' : 'span 3'
              }}
            >
              <MultiSelect
                id={'usage'}
                current={usage || ['']}
                entries={[
                  { label: labels.usage[1], value: 0, id: 'raw' },
                  { label: labels.usage[2], value: 1, id: 'cook' },
                  { label: labels.usage[3], value: 1, id: 'fry' },
                  { label: labels.usage[4], value: 1, id: 'steam' },
                  { label: labels.usage[5], value: 1, id: 'bake' },
                  { label: labels.usage[6], value: 1, id: 'waehe' },
                  { label: labels.usage[7], value: 1, id: 'compott' }
                ]}
                label={labels.usage[0]}
                change={handleNewFiltersChange}
              />
            </div>
          </FilterGrid>{' '}
        </Accordion>
      </FilterContainer>
    </>
  )
}

// const getWeek = (date: string | Date) => {
//   var d = new Date(new Date(date).getTime())
//   d.setHours(0, 0, 0, 0)
//   // Thursday in current week decides the year.
//   d.setDate(d.getDate() - (d.getDay() % 7))
//   // January 4 is always in week 1.
//   var week1 = new Date(d.getFullYear(), 0, 4)
//   // Adjust to Thursday in week 1 and count number of weeks from date to week1.
//   return (
//     1 +
//     Math.round(
//       ((d.getTime() - week1.getTime()) / 86400000 -
//         3 +
//         ((week1.getDay() + 6) % 7)) /
//         7
//     )
//   )
// }
